import { useEffect } from 'react'

export const JOIN_PARTNER_URL = 'https://s.autocall.ai/s/78dbab'

const JoinPartnerPage = () => {
  useEffect(() => {
    window.location.replace(JOIN_PARTNER_URL)
  }, [])

  return null
}

export default JoinPartnerPage
